import React from "react";
import { School, Library, Trophy } from "lucide-react";

const PILLARS = [
  { icon: School, label: "Schools" },
  { icon: Library, label: "Media Centers" },
  { icon: Trophy, label: "Activity Departments" },
];

export default function TrustSection() {
  return (
    <section
      data-testid="trust-section"
      className="bg-white py-24 md:py-32 border-y border-slate-200"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12 lg:px-16 text-center">
        <div className="text-xs uppercase tracking-[0.2em] font-bold text-teal mb-4">
          Trust
        </div>
        <h2
          data-testid="trust-headline"
          className="font-serif text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-navy leading-tight"
        >
          Built for Schools Like Yours
        </h2>
        <p className="mt-8 text-base sm:text-lg text-slate-600 leading-relaxed max-w-3xl mx-auto">
          ED Tech Depot works with schools, media centers, and activity departments to
          make in-house printing simple, reliable, and scalable.
        </p>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
          {PILLARS.map((p) => {
            const Icon = p.icon;
            return (
              <div
                key={p.label}
                data-testid={`trust-pillar-${p.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="flex flex-col items-center gap-4 py-8 border border-slate-200 rounded-2xl bg-[#F4F6F4] hover:border-teal hover:bg-white transition-all"
              >
                <div className="w-12 h-12 rounded-full bg-navy text-white flex items-center justify-center">
                  <Icon className="w-6 h-6" strokeWidth={2} />
                </div>
                <div className="font-serif text-lg font-bold text-navy">{p.label}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
